'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UITreeNode = function (_Component) {
  _inherits(UITreeNode, _Component);

  function UITreeNode(props) {
    _classCallCheck(this, UITreeNode);

    var _this = _possibleConstructorReturn(this, (UITreeNode.__proto__ || Object.getPrototypeOf(UITreeNode)).call(this, props));

    _this.renderIcon = function () {
      var node = _this.props.index.node;

      var openIcon = 'fa fa-folder-open';
      var closedIcon = 'fa fa-folder';

      var icon = _this.props.tree.getIcon && _this.props.tree.getIcon(node);
      if (icon) {
        openIcon = icon.open;
        closedIcon = icon.closed;
      }

      var collapsed = node.collapsed;

      return _react2.default.createElement('span', {
        className: (0, _classnames2.default)('icon', 'collapse-icon', collapsed ? closedIcon : openIcon),
        onMouseDown: function onMouseDown(e) {
          return e.stopPropagation();
        },
        onClick: _this.handleCollapse
      });
    };

    _this.renderChildren = function (options) {
      var _this$props = _this.props,
          index = _this$props.index,
          tree = _this$props.tree,
          dragging = _this$props.dragging,
          dropTarget = _this$props.dropTarget;


      if (index.children && index.children.length) {
        var childrenStyles = {
          paddingLeft: options && !isNaN(options.padding) ? options.padding : _this.props.paddingLeft
        };

        return _react2.default.createElement(
          'div',
          { className: 'children', style: childrenStyles },
          index.children.map(function (child) {
            var childIndex = tree.getIndex(child);

            return _react2.default.createElement(UITreeNode, {
              tree: tree,
              index: childIndex,
              key: childIndex.id,
              dragging: dragging,
              dropTarget: dropTarget,
              paddingLeft: _this.props.paddingLeft,
              onCollapse: _this.props.onCollapse,
              onDragStart: _this.props.onDragStart
            });
          })
        );
      }

      return null;
    };

    _this.onView = function (node, event) {
      event.stopPropagation();

      if (node.type === 'folder') {
        _this.handleCollapse(event);
        return;
      }

      // "Active experiment" node click does expand / collapse
      if (node.type === 'experiment' && node.id === -1) {
        _this.handleCollapse(event);
        return;
      }

      _this.props.tree.onView(node);
    };

    _this.renderButtons = function (node) {
      // no buttons on "Active experiment" node
      if (node.type === 'experiment' && node.id === -1) {
        return _react2.default.createElement('span', { className: 'buttonbar' });
      }

      // no buttons on experiment details
      if (node.type === 'experimentdetails') {
        return _react2.default.createElement('span', { className: 'buttonbar' });
      }

      var tree = _this.props.tree;
      var buttons = [];

      var index = _this.props.index;
      var parent = index.parent && tree.getIndex(index.parent).node;

      buttons.push(_react2.default.createElement('span', {
        key: 'edit',
        title: 'Edit this element',
        onMouseDown: function onMouseDown(e) {
          return e.stopPropagation();
        },
        onClick: function onClick(event) {
          event.stopPropagation();tree.onEdit(node, parent);
        },
        className: 'button fa fa-pencil' }));

      if (node.type === 'experiment') {
        buttons.push(_react2.default.createElement('span', {
          key: 'add',
          title: 'Add a sensor to this experiment',
          onMouseDown: function onMouseDown(e) {
            return e.stopPropagation();
          },
          onClick: function onClick(event) {
            event.stopPropagation();tree.onAdd(node);
          },
          className: 'button fa fa-plus' }));
      }

      return _react2.default.createElement(
        'span',
        { className: (0, _classnames2.default)('buttonbar', { 'dragging': _this.props.dragging }) },
        buttons
      );
    };

    _this.handleCollapse = function (e) {
      if (_this.props.index.node.leaf) {
        return;
      }

      e.stopPropagation();
      var nodeId = _this.props.index.id;

      if (_this.props.onCollapse) {
        _this.props.onCollapse(nodeId);
      }
    };

    _this.handleMouseDown = function (e) {
      var nodeId = _this.props.index.id;
      var node = _this.props.tree.getIndex(nodeId).node;

      if (node.type !== 'experiment' && node.type !== 'folder') {
        return;
      }

      // Can't drag 'Active experiment' node.
      if (node.type === 'experiment' && node.id === -1) {
        return;
      }

      // let dom = e.currentTarget.parentElement;
      var dom = e.currentTarget;

      if (_this.props.onDragStart) {
        _this.props.onDragStart(nodeId, dom, e);
      }
    };

    return _this;
  }

  _createClass(UITreeNode, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          tree = _props.tree,
          index = _props.index,
          dragging = _props.dragging;
      var node = index.node;

      var styles = {};

      if (index.id == 1) {
        return this.renderChildren({ padding: 0 });
      }

      var parent = index.parent && tree.getIndex(index.parent).node;

      var title = "";
      if (node.type === 'sensor') {
        title = "To add sensors, drag them onto the dashboard.";
      }

      return _react2.default.createElement(
        'div',
        {
          className: (0, _classnames2.default)('m-node', {
            'placeholder': index.id === dragging,
            'drop-not-allowed': index.id === dragging && !tree.canDropInPosition(node, parent),
            'active': node.id === -1
          }),
          style: styles,
          title: title
        },
        _react2.default.createElement(
          'div',
          {
            onMouseDown: this.handleMouseDown,
            className: (0, _classnames2.default)('inner', {
              'drop-target': index.id === this.props.dropTarget
            })
          },
          this.renderIcon(),
          _react2.default.createElement(
            'span',
            {
              className: 'nodewrapper',
              onClick: function onClick(event) {
                _this2.onView(node, event);
              }
            },
            tree.renderNode(node, parent, index.id)
          ),
          this.renderButtons(node),
          tree.renderTags && tree.renderTags(node)
        ),
        node.collapsed ? null : this.renderChildren()
      );
    }
  }]);

  return UITreeNode;
}(_react.Component);

module.exports = UITreeNode;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-ui-tree/dist/node.js
// module id = 1305
// module chunks = 2